import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./Pages/Layout";
import Home from "./Pages/Home";
import About from "./Pages/About";

import Contact from "./Pages/Contact";
import AdvanceHydroponicFarmingTechnology from "./Pages/AdvanceHydroponicFarmingTechnology";
import ExportShop from "./Pages/ExportShop";
import Products from "./Pages/Projects";
import Services from "./Pages/Services";
import NoPage from "./Pages/NoPage";
import Terms from "././Pages/Terms";
import Privacy from "././Pages/Privacy";
import Refund from "././Pages/Refund";
import FmcgProducts from "././Pages/FmcgProducts";
import CustomerReview from "././Pages/CustomerReview";

import OurProjects from "./Pages/OurProjects";

import WorkWithus from "./Pages/WorkWithus";
import Story from "./Pages/Story";

import RainProtectedWireRopeNetHouse from "./Pages/rain-protected-wire-rope-net-house";
import RequestAQuote from "./Pages/RequestAQuote";

import Videos from "./Pages/Videos";

import Login from "./Pages/Login";

import Dashboard from "./Pages/Dashboard";

import TawkToChat from "./Components/TawkToChat/TawkToChat";
import TunnelShadeHouse from "./Pages/tunnel-shade-net-house";

import Insulator_fittings_and_accessories from "./Pages/Insulator_fittings_and_accessories";
import Tension_clamp from "./Pages/Tension_clamp";
import Electric_fittings_and_components from "./Pages/Electric_fittings_and_components";
import Cross_arm from "./Pages/Cross_arm";
import SPDC_PAN from "./Pages/SPDC_PAN";

import CartModal from "./Components/CartModal";
import Checkout from "./Components/Checkout";

import Blog from "./Pages/Blog";
import Future_of_Power_Solar_and_Hybrid_Energy from "./Pages/Blog/Future_of_Power_Solar_and_Hybrid_Energy";
import Windmills_Powering_Tomorrow from "./Pages/Blog/Windmills_Powering_Tomorrow";

import { CartProvider } from "./Contexts/CartContext";

function App() {
  const [galleryData, setGalleryData] = useState([]);
  const [reviewData, setReviewData] = useState([]);
  const [isLogin, setIsLogin] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false); // State for cart modal visibility

  useEffect(() => {
    async function fetchGalleryData() {
      let tempgalleryData = await fetch(
        "//royalgreenhouse.co.in/crud.php?getGalleryData=true",
      )
        .then((response) => response.json())
        .then((response) => response)
        .catch((error) => {
          return "error";
        });
      if (tempgalleryData === "error") {
        console.log("php error");
      } else {
        setGalleryData(tempgalleryData);
      }
    }
    fetchGalleryData();

    async function fetchReviewData() {
      let tempReviewData = await fetch(
        "//royalgreenhouse.co.in/crud.php?getReviewData=true",
      )
        .then((response) => response.json())
        .then((response) => response)
        .catch((error) => {
          return "error";
        });
      if (tempReviewData === "error") {
        console.log("php error");
      } else {
        setReviewData(tempReviewData);
      }
    }
    fetchReviewData();
  }, []);

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen); // Toggle modal visibility
  };

  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout toggleCart={toggleCart} />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="fmcgProducts" element={<FmcgProducts />} />

            <Route
              path="tunnel-shade-net-house"
              element={<TunnelShadeHouse />}
            />

            <Route
              path="rain-protected-wire-rope-net-house"
              element={<RainProtectedWireRopeNetHouse />}
            />

            <Route
              path="Insulator_fittings_and_accessories"
              element={
                <Insulator_fittings_and_accessories toggleCart={toggleCart} />
              }
            />
            <Route
              path="Tension_clamp"
              element={<Tension_clamp toggleCart={toggleCart} />}
            />
            <Route
              path="Electric_fittings_and_components"
              element={
                <Electric_fittings_and_components toggleCart={toggleCart} />
              }
            />
            <Route
              path="Cross_arm"
              element={<Cross_arm toggleCart={toggleCart} />}
            />
            <Route
              path="SPDC_PAN"
              element={<SPDC_PAN toggleCart={toggleCart} />}
            />
            <Route path="login" element={<Login setLogin={setIsLogin} />} />
            <Route
              path="dashboard"
              element={
                <Dashboard
                  isLogin={isLogin}
                  galleryData={galleryData}
                  reviewData={reviewData}
                />
              }
            />

            <Route path="requestaquote" element={<RequestAQuote />} />
            <Route path="OurProjects" element={<OurProjects />} />

            <Route
              path="customerReview"
              element={<CustomerReview reviewData={reviewData} />}
            />
            <Route path="contact" element={<Contact />} />
            <Route path="products" element={<Products />} />
            <Route path="services" element={<Services />} />
            <Route path="WorkWithus" element={<WorkWithus />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="refund" element={<Refund />} />
            <Route
              path="advancehydroponicfarmingtechnology"
              element={<AdvanceHydroponicFarmingTechnology />}
            />
            <Route path="exportshop" element={<ExportShop />} />
            <Route path="story" element={<Story />} />
            <Route path="videos" element={<Videos />} />

            <Route path="Checkout" element={<Checkout />} />

            <Route path="blog" element={<Blog />} />
            <Route
              path="Future_of_Power_Solar_and_Hybrid_Energy"
              element={<Future_of_Power_Solar_and_Hybrid_Energy />}
            />
            <Route
              path="Windmills_Powering_Tomorrow"
              element={<Windmills_Powering_Tomorrow />}
            />
          </Route>
        </Routes>

        {isCartOpen && <CartModal toggleCart={toggleCart} />}
        <TawkToChat />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
